import React, { /* useEffect, */ useState } from "react";
/* import { useSubheader } from "../../_metronic/layout";
import { titleCase } from "../../_metronic/_helpers"; */
import { /* useSelector,  */connect } from "react-redux";
/* import { update } from "../modules/Auth/_redux/authCrud"; */
import { injectIntl } from "react-intl";
/* import { QuickToast } from "../modules/Components/Toast" */
import * as auth from "../modules/Auth/_redux/authRedux";
import '../../index.scss'
import { Table , Button, Modal, /* Form, */ Container, Row, Col, Card} from 'react-bootstrap';
import Axios from 'axios'
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";


function reGetTable() {
    return new Promise((res,_rej) =>{
        Axios.get(process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/verify")
            .then((response) => response.data)
            .then((data) => {
                return res( {status : true , data : data.reason})
            })
            .catch(() => {
                return res( { status : false })
            });

    })
}

function saveChanges(data, uid, message) {
    console.log(uid, message)
    let url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/verify/update"
    let save = new Promise((res,_rej) =>{
        Axios({
            method: 'post',
            url,
            data : {
                uid, 
                data,
                message
            }
        })
            .then((response) => response.data)
            .then(() => {
                return res( {status : true })
            })
            .catch(() => {
                return res( { status : false })
            });
    })
    return save
    //await Promise.resolve(save)
}

async function markAsComplete(uid) {
    let url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/verify/complete/"+ uid ;
    return new Promise((res,_rej) =>{
        Axios(url)
            .then((response) => response.data)
            .then(() => {
                return res( {status : true })
            })
            .catch(() => {
                return res( { status : false })
            });
    })
    //let result = await Promise.resolve(save)
}

function getDocuments(uid) {
    let url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/verify/documents/"+ uid ;
    let save = new Promise((res,_rej) =>{
        Axios(url)
            .then((response) => response.data)
            .then((data) => {
                //console.log(data.reason)
                return res(data.reason)
            })
            .catch(() => {
                return res( { status : false })
            });
    })
    //let result = await Promise.resolve(save)
    return save
}



function MyModal(props) {
    let {data, uid} = props

    let [message, setMessage] = useState("");
    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Document check
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        {
                            data.map( (img,i)=> {
                                return (
                                    <Row key={i} className="justify-content-center">
                                        <Col lg="12">
                                            <Card >
                                                <Card.Body>
                                                    <Card.Title>Documenent {i + 1}</Card.Title>
                                                    <img src={img.uri} width="100%" height="100%" alt= '' />
                                                    <div style={{ padding : 15, margin : 15 }}>
                                                        <label className="container_check">Valid?
                                                            <input type="checkbox"
                                                                onClick={({target}) => {
                                                                    if (target.checked){
                                                                        data[i].status = true
                                                                        target.removeAttribute('checked');
                                                                        target.parentNode.style.textDecoration = "";
                                                                    } else {
                                                                        data[i].status = false
                                                                        target.setAttribute('checked', true);
                                                                        target.parentNode.style.textDecoration = "line-through";
                                                                    }
                                                                    console.log(data[i].id, data[i].status)
                                                                }}
                                                                defaultChecked={data[i].status}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                )
                            })
                        }
                        <Row>
                            <Col lg='12' style={{padding : 5, margin : 5}}>
                                <h4>Comentary to user</h4>
                                <textarea style={{ height : 150, width : "100%" }} value={message} onChange={(event) =>  setMessage(event.target.value)}/>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onHide}>Close</Button>
                    <Button variant="success" onClick={ () => { 
                        saveChanges(data, uid, message).then( e =>  {
                            reGetTable().then(res => {
                                console.log(res)
                                setMessage("")
                                props.onHide()
                                props.update(res.data)
                            })
                        })
                    } }>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


function Elements({data, setData}){
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [uid, setUid] = useState("");

    return (
        <>
            <MyModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                data={modalData}
                uid={uid}
                update={setData}
            />
            <tbody className="Copy">
                {data.map((e,i) => (
                    <tr key={i} className="RowCopy">
                        <th className="EleRow">{i}</th>
                        <th><img src={e.user.uri} alt="Girl in a jacket" width="50" height="50"/></th>
                        <th className="EleRow">{e.user.name}</th>
                        {
                            e.code[0].toUpperCase() === 'O' ? <th className="EleRow" style={{color : 'red'}}>{e.code}</th> : <th className="EleRow" style={{color : '#ff8f40'}}>{e.code}</th>
                        }

                        <th>
                            <div
                                title="Edit Client"
                                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                                onClick={() => 
                                        getDocuments(e.id).then(docs => {
                                            setModalData(docs); 
                                            setUid(e.id)
                                            setModalShow(true)
                                        })
                                }
                            >
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                    <SVG
                                        src={toAbsoluteUrl("/media/svg/icons/General/Edit.svg")}
                                    />
                                </span>
                            </div>
                            <> </>

                            <div
                                title="Delete Client"
                                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                                onClick={() => 
                                        markAsComplete(e.id).then( e => {
                                            reGetTable().then( res => {
                                                setData(res.data)
                                            } ) 
                                        }) 
                                }
                            >
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Save.svg")} />
                                </span>
                            </div>
                        </th>
                    </tr>
                ))}
            </tbody>
        </>
    )
}

class UserVerify extends React.Component{

    state ={
        list : [],
        modalShow : false,
        search : false,
        filter : []
    }
    request = () =>{
        return new Promise((res,_rej) =>{
            Axios.get(process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/verify")
                .then((response) => response.data)
                .then((data) => {
                    return res( {status : true , data : data.reason})
                })
                .catch(() => {
                    return res( { status : false })
                });

        })
    }

    async componentDidMount(){
        let {data} = await this.request();
        this.setState({ list : this.state.list.concat(data) })
    }

    setElementData = (data) => {
        this.setState({ list : [...data] })
    }

    render(){
        return (

            <>
                <div
                    className="content d-flex flex-column flex-column-fluid"
                    id="kt_content"
                >
                    <div
                        className="subheader py-4 py-lg-4 subheader-solid"
                        id="kt_subheader"
                    >
                        <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                            <div className="d-flex align-items-center flex-wrap mr-2">
                                <h5 className=" mt-2 mb-2 mr-5">
                                    Profile Verification
                                </h5>
                                <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200"></div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div
                                    /* href="#" */
                                    className="btn btn-light btn-sm "
                                    id="kt_dashboard_daterangepicker"
                                    data-toggle="tooltip"
                                    title="Select dashboard daterange"
                                    data-placement="left"
                                >
                                    <span
                                        className="text-muted  mr-2"
                                        id="kt_dashboard_daterangepicker_title"
                                    >
                                        Today
                                    </span>
                                    <span
                                        className="text-primary "
                                        id="kt_dashboard_daterangepicker_date"
                                    >
                                        {new Date().toDateString()}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom gutter-b">
                        <div className="card-header d-flex justify-content-between">
                            <h5 className="mt-7 card-label"> Profile Verification </h5>
                        </div>

                        <div className="card-body">
                            <div className="col-lg-2">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="searchText"
                                    placeholder="Search"
                                    // onBlur={}
                                    //value={values.searchText}
                                    onChange={(e) => {
                                        let search = e.target.value
                                        if(search.length){
                                            this.setState({ search : true , filter : this.state.list.filter(e => e.user.name.toUpperCase().includes(search.toUpperCase()) )})
                                        }else{
                                            this.setState({search : false})
                                        }
                                    }}
                                />
                                <small className="form-text text-muted">
                                    <b>Search</b> in by name
                                </small>
                            </div>
                            <br />

                            <Table borderless size="sm" responsive>
                                <thead>
                                    <tr className="RowCopy">
                                        <th>#</th>
                                        <th>PICTURE</th>
                                        <th>NAME</th>
                                        <th>STATUS</th>
                                        <th>ACTION</th>
                                    </tr>
                                </thead>
                                <Elements data={this.state.search ? this.state.filter: this.state.list} setData={this.setElementData} />
                            </Table>

                        </div>
                    </div>
                </div>
            </>
        );
    }

}

export default injectIntl(connect(null, auth.actions)(UserVerify));
